const FIEL_PAUSE_CODE_RE =
  /FIEL|CREDENTIAL|CERTIFICADO|INVALID_FIEL|SAT_CREDENTIALS|FIEL_EXPIRED|FIEL_INTEGRITY|301|302/i;
const NON_FIEL_PAUSE_REASON_RE = /investig|emergency|drain|manual_pause|admin/i;

function isoIsFuture(iso) {
  if (!iso) return false;
  try {
    const d = new Date(iso);
    return Number.isFinite(d.getTime()) && d > new Date();
  } catch {
    return false;
  }
}

function isFielDownloadsPaused(form) {
  if (!form?.sat_downloads_paused) return false;
  const reason = String(form?.sat_downloads_paused_reason || "").trim();
  if (!reason) return true;
  if (NON_FIEL_PAUSE_REASON_RE.test(reason)) return false;
  return FIEL_PAUSE_CODE_RE.test(reason) || /contraseña|password|autentic/i.test(reason);
}

function isSatPortalWaiting(form) {
  if (form?.sat_downloads_paused) return false;
  return isoIsFuture(form?.sat_5002_next_retry_at) || isoIsFuture(form?.sat_cooling_off_until);
}

/**
 * Histórico ya cerrado (sync delta reusa ``pendiente``).
 * Incluye CFDI/XML ya cargados manualmente en Mongo (`has_local_cfdis` / `sat_sync_historical_complete`).
 */
function historicalSyncAlreadyCompleted(form) {
  if (form?.sat_sync_historical_complete === true) return true;
  if (form?.has_local_cfdis === true) return true;
  if (form?.sat_sync_has_local_cfdis === true) return true;
  if (Boolean(String(form?.sat_sync_completed_at || "").trim())) return true;
  const st = (form?.estado_sincronizacion || "").trim().toLowerCase();
  return st === "completado";
}

export function syncQueueStatusClass(estado) {
  const st = (estado || "").trim().toLowerCase();
  if (st === "procesando") return "bg-sky-100 text-sky-900 border-sky-200";
  if (st === "pendiente") return "bg-amber-50 text-amber-900 border-amber-200";
  if (st === "completado") return "bg-emerald-50 text-emerald-900 border-emerald-200";
  if (st === "error") return "bg-red-50 text-red-900 border-red-200";
  if (st === "fiel") return "bg-red-50 text-red-900 border-red-200";
  if (st === "portal") return "bg-amber-50 text-amber-900 border-amber-200";
  return "bg-slate-100 text-slate-700 border-slate-200";
}

/** Aviso compacto de cola SAT (solo título salvo FIEL o portal SAT). */
export function buildClientSatSyncQueueBanner(form) {
  if (isFielDownloadsPaused(form)) {
    return {
      label: "FIEL vencida o inválida",
      detail: "Cárguela de nuevo en Certificados y FIEL; la descarga continuará sola.",
      className: syncQueueStatusClass("fiel"),
    };
  }

  if (isSatPortalWaiting(form)) {
    return {
      label: "Falla temporal del portal SAT",
      detail: "En espera; el sistema seguirá la descarga cuando el SAT responda.",
      className: syncQueueStatusClass("portal"),
    };
  }

  const st = (form?.estado_sincronizacion || "").trim().toLowerCase();
  const historicalDone = historicalSyncAlreadyCompleted(form);

  if (st === "pendiente" || !st) {
    if (historicalDone) {
      return {
        label: "Sincronización al corriente",
        detail:
          "El histórico ya está en el sistema. Solo se revisan CFDI nuevos o huecos recientes en segundo plano.",
        className: syncQueueStatusClass("completado"),
      };
    }
    return {
      label: "Preparando descarga histórica",
      detail: "Primera integración desde la fecha de inicio configurada.",
      className: syncQueueStatusClass("pendiente"),
    };
  }
  if (st === "procesando") {
    return {
      label: historicalDone ? "Actualizando CFDI con SAT" : "Descargando histórico",
      detail: historicalDone
        ? "Revisión al corriente en curso (solo días recientes o huecos); puede cerrar la ventana."
        : "Descarga histórica inicial en curso; puede tardar según el periodo.",
      className: syncQueueStatusClass("procesando"),
    };
  }
  if (st === "completado") {
    return {
      label: "Sincronización al corriente",
      detail: "Los CFDI del periodo están en el sistema; solo se actualizan días nuevos.",
      className: syncQueueStatusClass("completado"),
    };
  }
  if (st === "error") {
    return {
      label: "Revisar sincronización",
      detail: "Revise la FIEL o el estado de sincronización SAT.",
      className: syncQueueStatusClass("error"),
    };
  }

  if (historicalDone) {
    return {
      label: "Sincronización al corriente",
      detail: "El histórico ya está en el sistema.",
      className: syncQueueStatusClass("completado"),
    };
  }
  return {
    label: "Preparando descarga histórica",
    detail: "",
    className: syncQueueStatusClass("pendiente"),
  };
}
